import {
  Button,
  Checkbox,
  Col,
  Divider,
  Modal,
  Row,
  Table,
  TabsProps,
  message,
  Form as FormAntd,
  Pagination,
} from "antd";
import styles from "./AllocationCost.module.scss";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  buildColumnsWithHeaderFilters,
  EditInCell,
  HeaderTable,
  Tabs,
  DatePicker,
  ModalImport,
  Form,
  PermissionDirect,
  TableActionButtons,
} from "../../Components";
import { Setting } from "../../assets/icon";
import { AllLocationCostApi, CommonApi } from "../../services";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";
import { resetPaginationToFirstPage } from "../../shared/helpers/pagination";
import { replaceRowByOriginalId } from "../../shared/helpers/rowState";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import {
  DeleteOutlined,
  EditFilled,
  PlusCircleOutlined,
} from "@ant-design/icons";
const { confirm } = Modal;
const AllocationCost = () => {
  // Define constant
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const [messageApi, contextHolder] = message.useMessage();
  const { isLocked, runLocked } = useRequestLock();
  const [editIndex, setEditIndex] = useState<any>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [filters, setFilters] = useState<any>({});
  const [activeTabs, setActiveTabs] = useState("1");
  const [onModalPostion, setOnModalPosition] = useState(false);
  const [valueDatePicker, setValueDatePicker] = useState<any>(new Date());
  const [openModalImport, setOpenModalImport] = useState(false);
  const [formInstance] = FormAntd.useForm();
  const canImportAllocation = checkPermissions(
    "ALLOCATION",
    "import",
    features,
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const handleAllocationFiltersChange = (nextFilters: any) => {
    setPagination((prev) => resetPaginationToFirstPage(prev));
    setFilters((prev: any) =>
      typeof nextFilters === "function" ? nextFilters(prev) : nextFilters,
    );
  };
  const typeDelivery = [
    { label: "BẮC - NAM", value: "ROAD" },
    { label: "CẢNG", value: "EXIM" },
    { label: "BIÊN", value: "BORDER" },
    { label: "ĐƯỜNG THUỶ", value: "WATERWAY" },
    { label: "CHUYỂN KHO", value: "TRANSFER" },
  ];
  const typeOnwerShip = [
    { label: "Đầu tư", value: "INVESTMENT" },
    { label: "Thuê khô", value: "DRY_RENTAL" },
    { label: "Dịch vụ", value: "SERVICE" },
  ];
  const REQUIRED_FIELDS = ["licensePlate"];
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Kế hoạch",
    },
    {
      key: "2",
      label: "Tồn kỳ trước",
    },
    {
      key: "3",
      label: "Phát sinh kỳ này",
    },
  ];
  const [colAlllocationEstimateCost, setColAlllocationEstimateCost] =
    useState<any>([
      {
        title: "#",
        dataIndex: "_id",
        width: 50,
        fixed: "left",
        hidden: false,
        render: (row: any, record: any, index: number) => index + 1,
      },
      {
        title: "Hình thức sở hữu",
        importTitle: "Hình thức sở hữu",
        dataIndex: "ownership",
        fixed: false,
        hidden: false,
        render: (row: any) =>
          typeOnwerShip.find((ite) => ite.value === row)?.label,
      },
      {
        title: "Hình thức VC",
        dataIndex: "roadType",
        importTitle: "Hình thức vận chuyển",
        fixed: false,
        hidden: false,
        render: (row: any) =>
          typeDelivery.find((ite) => ite.value === row)?.label,
      },
      {
        title: "Thuê khô",
        dataIndex: ["cost", "dryRental"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Khấu hao",
        dataIndex: ["cost", "depreciation"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Lãi vay",
        dataIndex: ["cost", "interest"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Săm lốp",
        dataIndex: ["cost", "tire"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Sửa chữa",
        dataIndex: ["cost", "repair"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Bảo dưỡng",
        dataIndex: ["cost", "maintenance"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Đăng kiểm",
        dataIndex: ["cost", "vehicleRegistration"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Bảo hiểm",
        dataIndex: ["cost", "vehicleInsurance"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Cầu đường",
        dataIndex: ["cost", "vehicleTollFee"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Bến bãi",
        dataIndex: ["cost", "vehicleEnteringFee"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Nhân công lái xe",
        dataIndex: ["cost", "laborDrivingFee"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Nhân công lái xe 2 tài",
        dataIndex: ["cost", "laborTwoDriverFee"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Nhân công khai thác",
        dataIndex: ["cost", "laborOperatingFee"],
        fixed: false,
        hidden: false,
        editType: "InputNumber",
        editProps: {
          formatter: (value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          control: false,
        },
        colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      },
      {
        title: "Người tạo",
        dataIndex: ["updatedBy", "name"],
        fixed: false,
        hidden: false,
      },
      {
        title: "Ngày tạo",
        dataIndex: "updatedAt",
        importTitle: (row: string) =>
          dayjs(row ?? new Date()).format("DD/MM/YYYY"),
        fixed: false,
        hidden: false,
        render: (row: any) => dayjs(row ?? new Date()).format("DD/MM/YYYY"),
      },
    ]);
  const colAlllocationVehicleCostBase = (
    type: "regularCost" | "incurredCost",
  ) => [
    {
      title: "#",
      dataIndex: "vehicleId",
      width: 50,
      fixed: "left",
      hidden: false,
      render: (row: any, record: any, index: number) => index + 1,
      tabs: "3",
    },
    {
      title: "Phương tiện",
      dataIndex: "licensePlate",
      filterDataIndex: "searchText",
      fixed: false,
      hidden: false,
      tabs: "3",
      filterConfig: {
        type: "string",
      },
    },
    {
      title: "Thuê khô",
      dataIndex: [type, "dryRental"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
    },
    {
      title: "Khấu hao",
      dataIndex: [type, "depreciation"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
    },
    {
      title: "Lãi vay",
      dataIndex: [type, "interest"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
    },
    {
      title: "Săm lốp",
      dataIndex: [type, "tire"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      tabs: "3",
    },
    {
      title: "Đăng kiểm",
      dataIndex: [type, "vehicleRegistration"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      tabs: "3",
    },
    {
      title: "Sửa chữa",
      dataIndex: [type, "repair"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      tabs: "3",
    },
    {
      title: "Bảo dưỡng",
      dataIndex: [type, "maintenance"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      tabs: "3",
    },
    {
      title: "Bảo hiểm",
      dataIndex: [type, "vehicleInsurance"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
    },
    {
      title: "Cầu đường",
      dataIndex: [type, "vehicleTollFee"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
    },
    {
      title: "Bến bãi",
      dataIndex: [type, "vehicleEnteringFee"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
    },
    {
      title: "Thuê moóc",
      dataIndex: [type, "trailerRental"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
    },
    {
      title: "Chi phí khác",
      dataIndex: [type, "otherExpense"],
      fixed: false,
      hidden: false,
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        control: false,
      },
      colReturn: (row: any) => (row ? row.toLocaleString("en-US") : 0) + " đ",
      tabs: "3",
    },
    {
      title: "Người tạo",
      dataIndex: ["costUpdatedBy", "name"],
      fixed: false,
      hidden: false,
      tabs: "3",
    },
    {
      title: "Ngày tạo",
      dataIndex: "updatedAt",
      fixed: false,
      hidden: false,
      render: (row: any) => dayjs(row).format("DD/MM/YYYY"),
      tabs: "3",
    },
  ];
  const configInputImportForm: any = {
    dataSource: {
      table: `posts`,
      update: {
        isBackendData: false,
      },
    },
    fields: [
      {
        displayType: "Group",
        dataIndex: "_id",
        col: { span: 24 },
        divider: true,
        className: [styles.FormItem].join(" "),
        fields: [
          {
            label: "Kỳ phân bổ", // show label
            dataIndex: "valid", // key
            displayType: "DatePicker", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              picker: "month",
              format: "MM/YYYY",
              placeholder: "Chọn tháng / năm",
              allowClear: false,
            },
          },
        ],
      },
    ],
  };
  const [colAlllocationVehicleCost, setColAlllocationVehicleCost] =
    useState<any>([]);
  // Function to create
  const toPath = (key: string | string[]) => {
    if (Array.isArray(key)) return key.map(String).filter(Boolean);
    // hỗ trợ "price.cont20" hoặc "price,cont20" (phòng khi bạn String(array) trước đó)
    return String(key)
      .split(/[.,]/g)
      .map((s) => s.trim())
      .filter(Boolean);
  };
  const setDeepImmutable = (obj: any, path: string[], value: any) => {
    if (!path.length) return obj;
    // clone root
    const next = { ...(obj || {}) };
    let cur: any = next;
    for (let i = 0; i < path.length; i++) {
      const k = path[i];
      const isLast = i === path.length - 1;
      if (isLast) {
        cur[k] = value;
      } else {
        const prev = cur[k];
        // clone từng tầng để tránh mutate
        cur[k] = typeof prev === "object" && prev !== null ? { ...prev } : {};
        cur = cur[k];
      }
    }
    return next;
  };
  const normalizeTouchedKey = (key: string | string[]) =>
    Array.isArray(key) ? key.join(".") : String(key);
  const hasNullRequiredField = (row: any) => {
    // field thường
    for (const key of REQUIRED_FIELDS) {
      if (key === "receipt" || key === "delivery") {
        if (!row[key] || (!row[key].wId && !row[key].value)) {
          return true;
        }
      } else {
        if (row[key] === null || row[key] === undefined) {
          return true;
        }
      }
    }
    return false;
  };
  const decorateEditColumns = (cols: any[]): any[] => {
    return cols.map((col: any) => {
      // 1) Nếu là group column -> đệ quy cho children, KHÔNG gắn render ở cột cha
      if (Array.isArray(col.children) && col.children.length > 0) {
        return {
          ...col,
          children: decorateEditColumns(col.children),
        };
      }
      // 2) Leaf column -> nếu có editType thì wrap render = EditInCell
      if (col.editType) {
        return {
          ...col,
          render: (cellValue: any, record: any) =>
            EditInCell({
              type: col.editType,
              // cellValue lúc này là value theo dataIndex (có thể là nested path)
              column: col?.colReturn
                ? col.colReturn(cellValue, record)
                : cellValue,
              index: record.key,
              dataIndex: col.dataIndex,
              editIndex,
              onChange: (value: any) => {
                handleUpdateRow(col.dataIndex, value, record.key);
                typeof col?.editProps === "function" &&
                  col?.editProps()?.onChange &&
                  col
                    .editProps(cellValue, record, editIndex)
                    .onChange(value, dataSource);
              },
              editProps:
                typeof col.editProps === "function"
                  ? col.editProps(cellValue, record, editIndex)
                  : {
                      ...col.editProps,
                      value: col.editProps?.value
                        ? col.editProps?.value(
                            cellValue,
                            record,
                            record.key,
                            editIndex,
                          )
                        : undefined,
                    },
            }),
        };
      }
      // 3) Leaf bình thường
      return { ...col };
    });
  };
  // Function to handle action
  const handleActionTable = (action: string, record: any, index: string) => {
    switch (action) {
      case "detail":
        //
        break;
      case "edit":
        setEditIndex([...editIndex, { index: index, record: { ...record } }]);
        break;
      case "delete":
        confirm({
          title: "Xác nhận xoá",
          content: "Bạn có chắc chắn muốn xoá bản ghi này không?",
          okText: "Xoá",
          cancelText: "Huỷ",
          okType: "danger",
          onOk() {
            // shortDeleteRouterBase({ ids: [index] as string[] })
            //   .then(() => {
            //     setDataSource((prev: any) =>
            //       prev.filter((item: any) => item._id !== record._id),
            //     );
            //     // // đồng thời xoá khỏi editIndex nếu đang edit
            //     setEditIndex((prev: any[]) =>
            //       prev.filter((item) => item.index !== index),
            //     );
            //   })
            //   .catch((error) => {
            //     messageApi.error(
            //       error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
            //     );
            //   });
          },
          onCancel() {},
        });
        // tìm index trong data theo id
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleActionSave = async (index: any, key: number) => {
    if (!checkPermissions("ALLOCATION", "edit", features)) {
      return;
    }

    await runLocked(`allocation-cost:estimate:${activeTabs}:${index}`, async () => {
      try {
        const rowEdit = editIndex.find((ind: any) => ind.index === index)?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }
        const originalRowId = rowEdit._id ?? index;
        // payload đúng shape API
        const payload = {
          depreciation: rowEdit.cost.depreciation ?? 0,
          interest: rowEdit.cost.interest ?? 0,
          tire: rowEdit.cost.tire ?? 0,
          dryRental: rowEdit.cost.dryRental ?? 0,
          repair: rowEdit.cost.repair ?? 0,
          maintenance: rowEdit.cost.maintenance ?? 0,
          vehicleRegistration: rowEdit.cost.vehicleRegistration ?? 0,
          vehicleInsurance: rowEdit.cost.vehicleInsurance ?? 0,
          vehicleTollFee: rowEdit.cost.vehicleTollFee ?? 0,
          vehicleEnteringFee: rowEdit.cost.vehicleEnteringFee ?? 0,
          laborDrivingFee: rowEdit.cost.laborDrivingFee ?? 0,
          laborTwoDriverFee: rowEdit.cost.laborTwoDriverFee ?? 0,
          laborOperatingFee: rowEdit.cost.laborOperatingFee ?? 0,
        };
        // // ===== CALL API =====
        const res = await AllLocationCostApi.putUpdateLocationEstimateCost(
          index,
          { cost: payload },
        );
        // ===== CHỈ KHI API OK =====
        if (res.success) {
          setDataSource((prev) =>
            replaceRowByOriginalId(prev, originalRowId, rowEdit),
          );
          setEditIndex((prev: any[]) =>
            prev.filter((ind: any) => ind.index !== index),
          );
        }
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionSaveVehicle = async (index: any, key: number) => {
    await runLocked(`allocation-cost:vehicle:${activeTabs}:${index}`, async () => {
      try {
        const rowEdit = editIndex.find((ind: any) => ind.index === index)?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }
        const requiredAction = rowEdit._id ? "edit" : "add";
        if (!checkPermissions("ALLOCATION", requiredAction, features)) {
          return;
        }
        const originalRowId = rowEdit._id ?? index;
        // ✅ check NULL các field req
        // ✅ check NULL các field req
        if (hasNullRequiredField(rowEdit)) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }
        const isNew = rowEdit._id;
        const vehicleId = rowEdit.vehicleId;
        // payload đúng shape API
        const payload = {
          incurredCost: {
            tire: rowEdit.incurredCost?.tire ?? 0,
            vehicleRegistration: rowEdit.incurredCost?.vehicleRegistration ?? 0,
            repair: rowEdit.incurredCost?.repair ?? 0,
            maintenance: rowEdit.incurredCost?.maintenance ?? 0,
            otherExpense: rowEdit.incurredCost?.otherExpense ?? 0,
          },
          regularCost: {
            depreciation: rowEdit.regularCost?.depreciation ?? 0,
            interest: rowEdit.regularCost?.interest ?? 0,
            tire: rowEdit.regularCost?.tire ?? 0,
            dryRental: rowEdit.regularCost?.dryRental ?? 0,
            vehicleRegistration: rowEdit.regularCost?.vehicleRegistration ?? 0,
            repair: rowEdit.regularCost?.repair ?? 0,
            maintenance: rowEdit.regularCost?.maintenance ?? 0,
            vehicleTollFee: rowEdit.regularCost?.vehicleTollFee ?? 0,
            vehicleEnteringFee: rowEdit.regularCost?.vehicleEnteringFee ?? 0,
            vehicleInsurance: rowEdit.regularCost?.vehicleInsurance ?? 0,
            trailerRental: rowEdit.regularCost?.trailerRental ?? 0,
            otherExpense: rowEdit.regularCost?.otherExpense ?? 0,
          },
        };
        // // ===== CALL API =====
        if (!isNew) {
          const res = await AllLocationCostApi.postAddAllocationCost({
            vehicle: vehicleId,
            period: {
              month: dayjs(valueDatePicker).format("MM"),
              year: dayjs(valueDatePicker).format("YYYY"),
            },
            ...payload,
          });
          // ===== CHỈ KHI API OK =====
          delete rowEdit.status;
          rowEdit._id = res?.data?._id;
        } else {
          const res = await AllLocationCostApi.putUpdateAllocationCost(
            rowEdit._id,
            payload,
          );
        }
        // ===== CHỈ KHI API OK =====
        setDataSource((prev) =>
          replaceRowByOriginalId(
            prev,
            originalRowId,
            !isNew
              ? {
                  ...rowEdit,
                  routeBase: prev.find(
                    (row: any) => (row._id ?? row.key) === originalRowId,
                  )?.routeBase,
                }
              : rowEdit,
          ),
        );
        setEditIndex((prev: any[]) =>
          prev.filter((ind: any) => ind.index !== index),
        );
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionCancel = (index: number) => {
    const editItem = editIndex.find((ind: any) => ind.index === index);
    if (editItem?.record?.status) {
      setDataSource((prev: any) => prev.filter((_: any) => _._id !== index));
    }
    const newEdit = editIndex.filter((ind: any) => ind.index !== index);
    setEditIndex(newEdit);
  };
  const handleUpdateRow = (
    key: string,
    value: string,
    index: string | number,
  ) => {
    setEditIndex((prev: any[]) => {
      const newEdit = [...prev];
      const findInd = newEdit.findIndex((item: any) => item.index === index);
      if (findInd === -1) return prev;
      const row = { ...newEdit[findInd] };
      const record = { ...(row.record || {}) };
      const path = toPath(key);
      const touchedKey = normalizeTouchedKey(key);
      // ✅ set nested field
      row.record = setDeepImmutable(record, path, value);
      // ✅ đánh dấu touched
      row.touchedFields = { ...(row.touchedFields || {}), [touchedKey]: true };
      newEdit[findInd] = row;
      return newEdit;
    });
  };
  const handleOnChangePosition = (
    dataIndex: string,
    value: boolean | "left" | "right",
    type: "hidden" | "fixed",
  ) => {
    setColAlllocationEstimateCost(
      colAlllocationEstimateCost?.map((col: any) =>
        col.dataIndex === dataIndex
          ? { ...col, [type]: type === "hidden" ? !value : value }
          : col,
      ),
    );
  };
  // Function to render
  const columnsRender = buildColumnsWithHeaderFilters(
    [
      ...decorateEditColumns(
        activeTabs === "1"
          ? colAlllocationEstimateCost
          : colAlllocationVehicleCost,
      ),
      {
        title: "",
        key: "action",
        width: 60,
        fixed: "right",
        render: (_: any, record: any, index: number) => {
          const saveRequestKey =
            activeTabs === "1"
              ? `allocation-cost:estimate:${activeTabs}:${_.key}`
              : `allocation-cost:vehicle:${activeTabs}:${_.key}`;
          const savePending = isLocked(saveRequestKey);
          const saveAction = record._id ? "edit" : "add";
          const canSave = checkPermissions(
            "ALLOCATION",
            saveAction,
            features,
          );
          return editIndex.find((ind: any) => ind.index === _.key) ? (
            <div>
              <Button
                loading={savePending}
                disabled={savePending || !canSave}
                onClick={() => {
                  activeTabs === "1"
                    ? handleActionSave(_.key, index)
                    : handleActionSaveVehicle(_.key, index);
                }}
              >
                Lưu
              </Button>{" "}
              <Button
                disabled={savePending}
                onClick={() => {
                  handleActionCancel(_.key);
                }}
              >
                Hủy
              </Button>
            </div>
          ) : (
            <TableActionButtons
              items={[
                {
                  key: "edit",
                  label: record._id ? "Chỉnh sửa" : "Tạo mới",
                  icon: record._id ? <EditFilled /> : <PlusCircleOutlined />,
                  tone: record._id ? "edit" : "info",
                  disabled: record._id
                    ? !checkPermissions("ALLOCATION", "edit", features)
                    : !checkPermissions("ALLOCATION", "add", features),
                  onClick: () => handleActionTable("edit", record, _.key),
                },
                {
                  key: "delete",
                  label: "Xoá",
                  icon: <DeleteOutlined />,
                  tone: "delete",
                  danger: true,
                  disabled:
                    activeTabs === "1" ||
                    !checkPermissions("ALLOCATION", "delete", features),
                  onClick: () => handleActionTable("delete", record, _.key),
                },
              ]}
            />
          );
        },
      },
    ],
    filters,
    handleAllocationFiltersChange,
  );
  const renderModalPosition = () => {
    return (
      <Modal
        open={onModalPostion}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          setOnModalPosition(false);
        }}
        title="Hiển thị cột"
        bodyProps={{
          style: {
            maxHeight: "70vh", // giới hạn theo chiều cao màn hình
            overflowY: "auto", // nội dung dài thì auto scroll
          },
        }}
        footer={false}
      >
        <Row>
          <Col span={16}>Tên cột</Col>
          <Col span={4}>Hiển thị</Col>
          <Col span={4}>Cố định(trái, phải)</Col>
        </Row>
        <Divider />
        {colAlllocationEstimateCost?.map((col: any, key: number) => {
          return key === colAlllocationEstimateCost.length ? null : (
            <div key={key}>
              <Row>
                <Col span={16}>{col.title}</Col>
                <Col span={4}>
                  <Checkbox
                    checked={!col.hidden}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked,
                        "hidden",
                      );
                    }}
                  />
                </Col>
                <Col span={4}>
                  <Checkbox
                    checked={col.fixed === "left" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "left",
                        "fixed",
                      );
                    }}
                    style={{ marginRight: "20px" }}
                  />
                  <Checkbox
                    checked={col.fixed === "right" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "right",
                        "fixed",
                      );
                    }}
                  />
                </Col>
              </Row>
              <Divider />
            </div>
          );
        })}
      </Modal>
    );
  };
  logger.debug(pagination);
  //Funtion to effect
  useEffect(() => {
    if (canImportAllocation) return;
    if (!openModalImport) return;

    setOpenModalImport(false);
    formInstance.resetFields();
  }, [
    canImportAllocation,
    formInstance,
    openModalImport,
  ]);
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      // setLoading(true);
      const params = {
        current: pagination.current,
        pageSize: pagination.pageSize,
        month: dayjs(valueDatePicker).format("MM"),
        year: dayjs(valueDatePicker).format("YYYY"),
        ...filters,
      };
      const res =
        activeTabs === "1"
          ? await AllLocationCostApi.getAllLocationEstimateCost(params)
          : await AllLocationCostApi.getAllLocationVehicleCost(params);
      logger.debug(res);
      if (mounted) {
        setDataSource(res?.data ?? []);
        setPagination((prev) => ({
          ...prev,
          total: res?.totalItem || 0,
        }));
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [
    filters,
    pagination.current,
    pagination.pageSize,
    valueDatePicker,
    activeTabs,
    // columns,
    // regionSelectOptions,
    // activeRowKey,
  ]);
  const handleAllocationTabChange = (tab: string) => {
    setPagination((prev) => resetPaginationToFirstPage(prev));
    setActiveTabs(tab);
    if (tab !== "1") {
      setColAlllocationVehicleCost(
        tab === "2"
          ? colAlllocationVehicleCostBase("regularCost")
          : colAlllocationVehicleCostBase("incurredCost").filter(
              (col: any) => col.tabs === "3",
            ),
      );
    }
  };
  const handleAllocationPeriodChange = (value: any) => {
    setPagination((prev) => resetPaginationToFirstPage(prev));
    setValueDatePicker(value);
  };
  // Main render
  return (
    <PermissionDirect screen={["ALLOCATION"]}>
      <div className={styles.AllocationCost}>
        {contextHolder}
        <div className="container">
          <HeaderTable
            title="Phân bổ"
            buttons={[
              {
                children: "Cài đặt hiển thị",
                icon: <Setting />,
                onClick: () => {
                  setOnModalPosition(true);
                },
                type: "primary",
              },
              {
                children: "Export",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  AllLocationCostApi.getExportAllLocationCost({
                    month: dayjs(valueDatePicker).format("MM"),
                    year: dayjs(valueDatePicker).format("YYYY"),
                  });
                },
                style: {
                  backgroundColor: checkPermissions(
                    "ALLOCATION",
                    "export",
                    features,
                  )
                    ? "#00B69B"
                    : "#C0C0C0",
                },
                disabled: !checkPermissions("ALLOCATION", "export", features),
              },
              {
                children: "Mẫu import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  if (!checkPermissions("ALLOCATION", "export", features)) {
                    return;
                  }
                  CommonApi.getDownloadTemplate("allocationCost", "Phân bổ.xlsx");
                },
                type: "primary",
                disabled: !checkPermissions("ALLOCATION", "export", features),
              },
              {
                children: "Import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  if (!canImportAllocation) return;
                  setOpenModalImport(true);
                },
                style: {
                  backgroundColor: checkPermissions(
                    "ALLOCATION",
                    "import",
                    features,
                  )
                    ? "#00529F"
                    : "#C0C0C0",
                },
                disabled: !checkPermissions("ALLOCATION", "import", features),
              },
              // {
              //   children: "Thêm mới",
              //   icon: <PlusIcon />,
              //   onClick: handleAddRow,
              //   style: { backgroundColor: "#0076E3" },
              // },
            ]}
          />
          <Row align="middle" justify="space-between">
            <Tabs
              activeKey={activeTabs}
              items={items}
              onChange={handleAllocationTabChange}
            />
            {/* {selectedRowKeys.length > 0 && (
            <Button danger type="primary" onClick={handleOnShortDeleted}>
              Xoá
            </Button>
          )} */}
            <DatePicker
              picker="month"
              format="MM/YYYY"
              placeholder="Chọn tháng / năm"
              value={dayjs(valueDatePicker)}
              onChange={handleAllocationPeriodChange}
              allowClear={false}
            />
          </Row>
          <Table
            dataSource={dataSource}
            columns={columnsRender}
            pagination={{
              pageSize: pagination.pageSize,
              current: pagination.current,
              total: pagination.total,
              onChange: (page, pageSize) => {
                setPagination((prev) => ({
                  ...prev,
                  current: page,
                  pageSize: pageSize || prev.pageSize,
                }));
              },
              showSizeChanger: true,
            }}
            rowKey={(record) => String(record.key || record._id)}
            size="small"
            bordered
          />
        </div>
        <ModalImport
          columnsBySheet={{
            "Kế hoạch": colAlllocationEstimateCost.filter(
              (col: any) => !["Người tạo", "Ngày tạo"].includes(col.title),
            ),
            "Tồn kỳ trước": colAlllocationVehicleCostBase("regularCost").filter(
              (col: any) => !["Người tạo", "Ngày tạo"].includes(col.title),
            ),
            "PS kỳ này": colAlllocationVehicleCostBase("incurredCost").filter(
              (col: any) =>
                col.tabs === "3" &&
                !["Người tạo", "Ngày tạo"].includes(col.title),
            ),
          }}
          multipleColumns={true}
          open={openModalImport}
          onCancel={() => {
            setOpenModalImport(false);
            formInstance.resetFields();
          }}
          precheckApi={async (file: Blob) => {
            if (!canImportAllocation) {
              throw new Error("Bạn không có quyền import phân bổ");
            }
            return AllLocationCostApi.postPreCheckImportAllLocationCost(file);
          }}
          confirmApi={(payload) => {
            if (!canImportAllocation) {
              return Promise.reject(
                new Error("Bạn không có quyền import phân bổ"),
              );
            }
            return formInstance.validateFields().then(() => {
              const val = formInstance.getFieldsValue(["valid"]);
              return AllLocationCostApi.postConfirmImportAllLocationCost({
                fileName: payload.fileName,
                period: {
                  month: dayjs(val.valid).format("MM"),
                  year: dayjs(val.valid).format("YYYY"),
                },
              }).then(() => {
                formInstance.resetFields();
              });
            });
          }}
        >
          <Form form={formInstance} {...configInputImportForm} />
        </ModalImport>
        {renderModalPosition()}
      </div>
    </PermissionDirect>
  );
};
export { AllocationCost };
